module.exports = __webpack_public_path__ + "img/117.0dc044f5.jpg";